module.exports = __webpack_public_path__ + "static/media/arrow-left-gray-small.50aafe82.svg";